import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BsEye, BsPlusCircleFill, BsQuestionSquare } from "react-icons/bs";
import { FaCalendarAlt, FaSearch } from "react-icons/fa";
import { RiArrowLeftSLine, RiArrowRightSLine, RiFolderInfoLine } from "react-icons/ri";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import Get from "../api/Get";
import { DOCTOR_BY_EMAIL, PACIENTE_LIST } from "../api/Routes";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import SimpleTable from "../components/SimpleTable";
import { authContext } from "../context/AuthContext";
import useCompanyType from "../hook/useCompanyType";
import LoadingList from "../loader/LoadingList";

function DoctorPacientes({t, perfil}){
    const [idDoctor, setIdDoctor] = useState(null)
    const [items, setItems] = useState([])
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(20)
    const [order, setOrder] = useState('name')
    const [pageCount, setPageCount] = useState(0)
    const {auth} = useContext(authContext)
    const [loading, setLoading] = useState(true)
    const [valueSearch, setValueSearch] = useState('')
    const [search, setSearch] = useState("%20") 
    const companyType = useCompanyType()  

    //handle server error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false) 

    //buscamos el doctor
    useEffect(()=>{
        if(!idDoctor){
            let mounted = true
            const url = encodeURI(`${DOCTOR_BY_EMAIL}/${auth.data.username}`)
            setLoading(true)

            Get({url: url, access_token: auth.data.access_token})
            .then((response) => {
                if(mounted){
                    setIdDoctor(response.data.data.id)
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
            return () => mounted = false;
        }
    }, [])

    useEffect(()=>{
        setLoading(true)
        const url = `${PACIENTE_LIST}/${page}/${count}/${order}/${search}`
        Get({url: url, access_token: auth.data.access_token})
        .then(response=>{
            setItems(response.data.data.response.content)
            setPageCount(response.data.data.response.totalPages)
            setLoading(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [page, count, search])

    const actions = (cell, row, index) => {
        return (
            <div>
                <ul className="list-inline mb-0">
                    <li className="list-inline-item"><Link to={`/admin/doctor/patient/${row.id}`}><BsEye className='iconAction colorNaranja' /></Link></li>
                    <li className="list-inline-item"><Link to={`/admin/proveedor/citas/${idDoctor}/${row.id}`}><FaCalendarAlt className='iconAction colorVerde' /></Link></li>
                    <li className="list-inline-item"><Link to={`/admin/patients/misrespuestas/${row.id}`}><BsQuestionSquare className='iconAction' /></Link></li>
                    <li className="list-inline-item"><Link to={`/admin/patients/trazabilidad/${row.id}`}><RiFolderInfoLine className='iconAction colorRojo'/></Link></li>
                </ul>          
            </div>
        );
    }
    const fillName = (cell, row) => {
        let firstName = `${row.name.toUpperCase() ?? ''}`
        let secname = `${row.middleName?.toUpperCase() ?? ''}`
        let firstAp = `${row.lastName.toUpperCase() ?? ''}`
        let secAp = `${row.seccondSurname?.toUpperCase() ?? ''}`
        return `${firstName} ${secname} ${firstAp} ${secAp}`
    }
    const fillDocumento = (cell, row) => {
        return cell ? `${row.identityDocumentType?.code}: ${cell}` : ''
    }
    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, 
        {
            dataField: 'name',
            text: t('Nombre'),
            headerStyle: { width: '30%' },
            formatter: fillName,  
        },
        companyType === "colombia" ?
        {
            dataField: 'documentNumber',
            text: 'Documento de identidad',
            headerStyle: { width: '10%' },
            formatter: fillDocumento,
        } :
        {
            dataField: 'externalId',
            text: 'No. Poliza',
            headerStyle: { width: '10%' },
        },
        {
            dataField: 'phoneNumber',
            text: t('Telefono'),
            headerStyle: { width: '10%' },
        },
        {
            dataField: 'email',
            text: t('Correoelectronico'),
            headerStyle: { width: '30%' },
        },
        {
            dataField: '',
            isDummyField: true,
            text: t('acciones'),
            headerStyle: { width: '20%' },
            formatter: actions,            
        }
    ]

    const handlePageClick = (data) =>{
        setPage(data.selected)
    }   
    
    const searchPatient = e =>{
        e.preventDefault();
        if(valueSearch===""){
            setSearch("%20")            
        }else{
            setSearch(valueSearch)
        }
        setPage(0)        
    }

    return(
        <Container fluid className="my-5">
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">{t('pacientes')}</h2>
                </Col>
                <Col xs="12" md="4">
                    <Row className="align-items-center">
                        <Col xs="8" md="9">
                            <Form onSubmit={searchPatient}>
                                <InputGroup>
                                    <FormControl
                                        placeholder={t('buscar')}
                                        className="input-1"
                                        value={valueSearch}
                                        onChange={e=>setValueSearch(e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button type="submit" variant="outline-secondary" className="input-span-1"><FaSearch/></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form>
                        </Col>
                        <Col xs="4" md="3" className="text-right">
                            <Link to={`/admin/patients/create`}><BsPlusCircleFill className="add-btn"/></Link>                        
                        </Col>
                    </Row>
                    {/* <Row className="align-items-center">
                        <Col xs="12" md="12">
                            <Form onSubmit={searchPatient}>
                                <InputGroup>
                                    <FormControl
                                        placeholder={t('buscar')}
                                        className="input-1"
                                        value={valueSearch}
                                        onChange={e=>setValueSearch(e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button type="submit" variant="outline-secondary" className="input-span-1"><FaSearch/></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>                 */}
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>
                            {loading && <LoadingList />}
                            <SimpleTable columns={columns} items={items} className="th-text-uppercase"/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs="12" md="10">
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
                <Col className="d-none d-md-block" xs="12" md="2">
                    <select className="select-pagin" onChange={e=>setCount(e.target.value)}>
                        <option value="20">20 / {t('pagina')}</option>
                        <option value="30">30 / {t('pagina')}</option>
                        <option value="50">50 / {t('pagina')}</option>
                    </select>
                </Col>
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </Container>        
    )

}

export default withTranslation()(DoctorPacientes)